import React from 'react'
import { Footer } from "../../components"

const FooterContainer = () => {
  return (
    <Footer />
  )
}

export default FooterContainer